import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Session } from '@core/models';

export const SessionActions = createActionGroup({
  source: 'Session',
  events: {
    'Load Session': props<{
      idWorker: number;
      token: any;
    }>(),
    'Load Session Success': props<{ session: Session }>(),
    'Load Session Failure': props<{ error: string }>(),
    'Clear Session': emptyProps(),
  },
});
